export default class SearchQueryParser {

	public static execute (search: string) {
		const query: { [s: string]: string } = {};

		if (search.length === 0) {
			return query;
		}

		search.replace('?', '').split('&').forEach(parameter => {
			const split = parameter.split('=');
			query[split[0]] = decodeURIComponent(split[1]);
		});

		return query;
	}
}


// WEBPACK FOOTER //
// ./code/foundation/parsers/SearchQueryParser.ts